import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GenerateAssetRBAC = {
  pageID: '5c4e145a7241e47fc9e5d6dcae4ab853',
  elementID: {
    BtnRegisPallet: '37a601b787be14e44c940105d3ad6bc3',
    BtnUnassign: 'd08bd3deb439199380d59f5b1a8e60ef',
    BtnBulkUpload: 'df518d9e55ca8c39522c8551d90ba33a',
  },
} as const

export const useRBACGenerateAssetPage = createUseRBAC(GenerateAssetRBAC.elementID)

export type UseRBACGenerateAssetPageType = ReturnType<typeof useRBACGenerateAssetPage>
